const LIGHT_SPINNER_VARIANTS = new Set(['primary', 'dark', 'plumLilac']);

export const getButtonLoadingSpinnerVariant = buttonVariant =>
  LIGHT_SPINNER_VARIANTS.has(buttonVariant) ? 'light' : 'dark';
